"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachWalletButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const icons_material_1 = require("@mui/icons-material");
const notistack_1 = require("notistack");
const uuid_1 = require("uuid");
const wagmi_1 = require("wagmi");
const viem_1 = require("viem");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const constants_1 = require("@dzambalaorg/constants");
const provider_user_1 = require("@dzambalaorg/provider-user");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const AttachWalletButton = () => {
    const [data, setData] = (0, react_1.useState)({ nonce: "", signature: "", wallet: "" });
    const { address: account, connector } = (0, wagmi_1.useAccount)();
    const { data: client } = (0, wagmi_1.useWalletClient)();
    const { enqueueSnackbar } = (0, notistack_1.useSnackbar)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const user = (0, provider_user_1.useUser)();
    const attachCall = (0, react_hooks_1.useApiCall)(async (api, values) => {
        return api
            .fetchJson({
            url: "/profile/wallet",
            method: "POST",
            data: values,
        })
            .then(() => {
            return user.getProfile();
        })
            .catch((e) => {
            enqueueSnackbar(formatMessage({ id: `snackbar.${e.message}` }), { variant: "error" });
        });
    }, { success: false, error: false });
    const { execute: metaAttachFn } = (0, react_hooks_eth_1.useMetamask)(async () => {
        const provider = await connector.getProvider();
        const walletClient = (0, viem_1.createWalletClient)({
            chain: client.chain,
            transport: (0, wagmi_1.custom)(provider),
        });
        return walletClient
            .signMessage({ account: walletClient.account, message: `${constants_1.phrase}${data.nonce}` })
            .then((signature) => {
            setData({ ...data, wallet: account, signature });
            return attachCall.fn(void 0, { ...data, wallet: account, signature });
        });
    }, { success: false });
    const handleAttach = async () => {
        await metaAttachFn();
    };
    (0, react_1.useEffect)(() => {
        setData({ nonce: (0, uuid_1.v4)(), signature: "", wallet: account || "" });
    }, [account]);
    return !user.profile.wallet ? ((0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.AccountBalanceWallet, {}), onClick: handleAttach, "data-testid": "AttachWalletButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.profile.settings.wallet.attach" }) })) : null;
};
exports.AttachWalletButton = AttachWalletButton;
//# sourceMappingURL=index.js.map